
<script>
export default {
  name: 'RexCheckboxesGroup',
  props: {
    name: {
      type: String,
      default: () => null,
      required: true
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    getter: {
      type: String,
      default: () => 'getField'
    },
    setter: {
      type: String,
      default: () => 'setField'
    },
    label: {
      type: String,
      default: () => null
    },
    options: {
      type: Array,
      default: () => []
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
    defaultShow: {
      type: Number,
      default: () => 0
    },
    hasBackendValidation: {
      type: Boolean,
      default: () => false
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    }
  },
  inject: ['$validator'],
  data: () => ({
    showAll: false,
  }),
  computed: {
    value: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getter}`](this.target)
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setter}`, {
          target: this.target,
          value
        })

        if (this.error !== null && this.hasBackendValidation) {
          const target = this.target.split('.')
          const err = this.$store.getters[`${this.storeModule}/${this.getter}`](`${target[0]}Errors`)
          const currentFieldErrorIndex = err.map(x => x.source).indexOf(this.name)

          err.splice(currentFieldErrorIndex, 1)
          this.$store.commit(`${this.storeModule}/${this.setter}`, err)
        }

        this.$emit('change', {
          event: value,
          element: this.$vnode.elm
        })
      }
    },
    error() {
      let error = null

      if (this.hasBackendValidation) {
        const target = this.target.split('.')
        const err = this.$store.getters[`${this.storeModule}/${this.getter}`](`${target[0]}Errors`)
          .find(item => item.source === this.name)

        error = err ? err.detail : null
      }

      return error
    },
    isSelectedAll() {
      return this.value.length === this.options.length
    },
    isNoSelected() {
      return this.value.length === 0
    },
    optionsList() {
      let options

      if (this.showAll || !this.defaultShow) {
        options = this.options
      } else {
        options = this.options.slice(0, this.defaultShow)
      }

      return options
    },
    showSelectActionsButtons() {
      return !(this.defaultShow) || this.options.length <= this.defaultShow || this.showAll
    }
  },
  created() {
    this.showAll = this.defaultShow && this.value.length >= this.defaultShow
  },
  methods: {
    selectAll() {
      if (!this.disabled) {
        this.value = this.options.map(item => item.slug)
      }
    },
    reset() {
      if (!this.disabled) {
        this.value = []
      }
    }
  }
}
</script>

<template>
  <b-field
    custom-class="rex-label"
    :label="label"
    :type="{'is-danger': errors.has(name) || error}"
    :message="errors.first(name) || error"
  >
    <div
      class="rex-checkboxes-group"
      :class="{
        'rex-checkboxes-group--disabled': isDisabled
      }"
    >
      <div class="rex-checkboxes-group__options">
        <b-checkbox
          v-for="option in optionsList"
          :key="option.slug"
          v-model="value"
          v-validate="validate"
          :name="name"
          :disabled="isDisabled || option.disabled"
          :true-value="option.slug"
          :native-value="option.slug"
          class="rex-checkbox"
        >
          <div class="rex-checkbox__label">
            <span>{{ option.name }}</span>
            <span
              v-if="option.badge"
              class="rex-checkbox__badge"
            >
              {{ option.badge }}
            </span>
          </div>
        </b-checkbox>
      </div>
      <div
        v-if="defaultShow && !showAll && options.length > defaultShow"
        class="rex-checkboxes-group__show-more"
      >
        <button
          @click="showAll = true"
        >
          Показать все ({{ options.length }})
        </button>
      </div>
      <div class="rex-checkboxes-group__actions">
        <div>
          <button
            v-if="!isSelectedAll && showSelectActionsButtons"
            @click="selectAll"
          >
            Выбрать все
          </button>
        </div>
        <div>
          <button
            v-if="!isNoSelected && showSelectActionsButtons"
            @click="reset"
          >
            Сбросить
          </button>
        </div>
      </div>
    </div>
  </b-field>
</template>